import { gql } from '@apollo/client';
import { ERRORS_FRAGMENT, ITINERARY_FRAGMENT } from '@/graphql/fragments';

export const RESERVE_KIU_FLIGHTS = gql`
    ${ERRORS_FRAGMENT}
    ${ITINERARY_FRAGMENT}
    mutation KiuReserveFlights($input: String!) {
        kiuReserveFlights(input: $input) {
            status
            errors {
                ...ErrorType
            }
            customErrors {
                field
                messages
                code
            }
            itinerary {
                ...ItineraryType
            }
        }
    }
`;

export const KIU_PASSENGER_FORM = gql`
    ${ERRORS_FRAGMENT}
    mutation KiuPassengerForm($input: KIUPassengerFormInput!) {
        kiuPassengerForm(input: $input) {
            status
            errors {
                ...ErrorType
            }
            response
        }
    }
`;
